import { useMutation, useQueryClient } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { CandidacyPlacement, HttpResponse } from "@/types";

// Sets the expected start date on a placement that doesn't have one yet.
export function useUpdateSetPlacementDateSetToStart() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      companyId,
      jobId,
      id,
      dateSetToStart,
    }: {
      companyId: string;
      jobId: string;
      id: number;
      dateSetToStart: string;
    }) => {
      const path = `companies/${companyId}/jobs/${jobId}/placements/${id.toString()}`;
      const res = await guacHttpClient.patch<
        CandidacyPlacement,
        HttpResponse<CandidacyPlacement>
      >(path, { dateSetToStart });

      return res.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["staffer-earnings"] });
    },
  });
}
